<template>
    <DelegateApprovals></DelegateApprovals>
</template>
<script>
    import DelegateApprovals from '@/components/EmployeeDelegateApprovals.vue'
    export default {
        name: 'funding-management',
        components: {
            DelegateApprovals
        }
    }
</script>